import React, { useContext } from 'react';
import styled from 'styled-components';
import { FlexContainer, Text } from 'common/styles';
import illustrationConfig from 'styles/illustrations';
import { OSContext } from 'ui/containers/Providers/OSProvider';

const Container = styled(FlexContainer)`
  height: 100%;
  flex-direction: column;
  background: #fff;
  justify-content: center;
  border-radius: 6px;
  a {
    color: #0161ff;
  }
`;

const Button = styled.button`
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  background: #0061ff;
  border-radius: 51px;
  padding: 6px 16px;
  border: none;
  outline: none;
  margin-top: 24px;
  cursor: pointer;
  font-weight: 500;
`;

const Wrapper = styled.div`
  height: 100vh;
  overflow: hidden;
  padding: 24px;
`;

const ErrorPage = ({ error, componentStack, resetError }) => {
  const { activeOS } = useContext(OSContext);
  return (
    <Wrapper>
      <Container>
        <img
          src={illustrationConfig.errorPage[activeOS]}
          alt="no inbox permission"
          width="520px"
          height="238px"
        />
        <Text color={'#12151A'} fontSize={20} lineHeight={30} margin={'30px 0 0'}>
          Oops! Something went wrong.
        </Text>
        <div>{error.toString()}</div>
        <Text color={'#525F76'} margin={'12px 0 0'}>
          Try again or check out our{' '}
          <a href="https://help.zoominfo.com/s/global-search/chat" target="_blank" rel="noreferrer noopener">
            Help Center.
          </a>
        </Text>
        <Button onClick={() => window.location.reload()}>Try Again</Button>
      </Container>
    </Wrapper>
  );
};

export default ErrorPage;
